module.exports = __webpack_public_path__ + "static/media/menu-close.6242fad4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/svg/menu-close.svg
// module id = 485
// module chunks = 0